import { CIcon } from '~/icons/types'

export const ciTrucks: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.934 15.694h-.78a.665.665 0 0 1-.61-.71.655.655 0 0 1 .61-.7h.75a5.923 5.923 0 0 0-.39-1.57 3.242 3.242 0 0 0-.17-.32l-.38-.66-1.04-1.8-.56-.99-.39-.68-.02-.02a2.321 2.321 0 0 0-1.94-1.06h-4.44v10.29h1.07v-.02a3.205 3.205 0 1 1 6.41 0v.02h1.41a.484.484 0 0 0 .35-.15.5.5 0 0 0 .14-.35l-.02-1.28Zm-6.1-2.98c-.99 0-1.2-.56-1.2-1.03v-1.71a.882.882 0 0 1 .42-.92 3.036 3.036 0 0 1 1.2-.11h1.97l.55.99 1 1.8.55.98h-4.49Z'
    },
    {
      d:
        'M18.857 15.184a2.27 2.27 0 0 0-2.27 2.269v.014a2.278 2.278 0 0 0 1.678 2.175 2.423 2.423 0 0 0 .595.075 2.275 2.275 0 0 0 2.264-2.255v-.014a2.265 2.265 0 0 0-2.267-2.264ZM13.035 4.285H.538a.493.493 0 0 0-.492.493v13.035a.493.493 0 0 0 .492.493h2.1a2.864 2.864 0 0 1-.075-.357v-.009l-.005-.023a3.009 3.009 0 0 1-.033-.46 3.207 3.207 0 0 1 6.413 0c0 .15-.01.301-.033.45v.02c-.02.126-.046.25-.08.374h4.219a.493.493 0 0 0 .492-.493V4.778a.493.493 0 0 0-.501-.493Z'
    },
    {
      d:
        'M5.727 15.184a2.27 2.27 0 0 0-1.584 3.891c.225.22.493.39.787.5.029.01.052.02.08.029l.089.028h.014l.061.014c.014.005.028.005.042.009a1.1 1.1 0 0 0 .15.028h.066c.014 0 .042.005.066.009h.014c.065 0 .136.01.206.01A2.27 2.27 0 0 0 7.823 18.3a2.44 2.44 0 0 0 .14-.515 2.61 2.61 0 0 0 .024-.333 2.256 2.256 0 0 0-2.26-2.27Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'trucks',
  type: 'solid'
}
